<template>
    <div class="cc-voucher">
        <div class="cc-voucher__header" v-if="!shouldInputBeShown">
            <div class="cc-voucher__title" @click="showInput">{{ translations['I have a voucher'] }}</div>
        </div>
        <div class="cc-voucher__main">
            <div class="cc-form-input" v-if="shouldInputBeShown">
                <input type="text" class="cc-input cc-input--text cc-input--medium cc-input--with-button" v-bind:class="{'cc-invalid': isVoucherInvalid}" size="15" v-model="voucherCode" :placeholder="translations['Voucher']" @keyup.enter="applyVoucher">
                <button class="cc-button cc-button--apply-voucher" :title="translations['Apply voucher']" @click="applyVoucher">{{ translations['Ok'] }}</button>
                <div class="cc-alert cc-alert--error" v-if="isVoucherInvalid">{{ translations['Voucher is invalid'] }}</div>
            </div>
            <div v-for="voucher in vouchers" v-bind:key="voucher.code" class="cc-voucher-code">
                <div class="cc-voucher-code__title">{{ voucher.code }} <button class="cc-button cc-button--remove-voucher" :title="translations['Remove voucher']" @click="removeVoucher(voucher.code)">&times;</button></div>
                <div class="cc-voucher-code__value">{{ voucher.value }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        computed: {
            ...mapState({
                translations: state => state.translations,
                vouchers: state => state.voucher.vouchers,
            }),
        },
        data () {
            return {
                voucherCode: null,
                isVoucherInvalid: false,
                shouldInputBeShown: false,
            };
        },
        methods: {
            showInput: function () {
                this.shouldInputBeShown = true;
            },
            applyVoucher: function () {
                this.$store.dispatch('voucher/apply', this.voucherCode)
                    .then((result) => {
                        if (result === false) {
                            this.isVoucherInvalid = true;
                            return;
                        }

                        this.isVoucherInvalid = false;
                        this.shouldInputBeShown = false;
                        this.voucherCode = '';
                    });
            },
            removeVoucher: function (code) {
                this.$store.dispatch('voucher/remove', code);
            },
        },
        name: 'Voucher',
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/voucher";
</style>
